import { FC } from "react"
import { useTranslation } from "react-i18next"
import { Box } from "@mui/material"

import { UButton, UModalPopup, UText } from "../../ui-component"

export interface CancelUAssistModalProps {
  /** Whether the modal is open */
  open: boolean
  /** Called when the user dismisses the modal (No or overlay) */
  onClose: () => void
  /** Called when the user confirms cancelling uAssist submission */
  handleConfirmCancelUAssist: () => void
}

const CancelUAssistModal: FC<CancelUAssistModalProps> = ({
  open,
  onClose,  
  handleConfirmCancelUAssist,
}) => {
  const { t } = useTranslation("common")

  if (!open) return null

  return (
    <UModalPopup
      isAlert={open}
      title={
        <UText variant="h6">
          {t("overview.cancelUassist.title")}
        </UText>
      }
      sxModalProps={{
        ".MuiDialog-paper": {
          maxWidth: 444,
        },
        "#titleCntr": {
          padding: "16px 24px",
        },
        "#contentCntr": {
          padding: "20px 24px",
        },
        "#btnListCntr": {
          padding: 2,
          gap: 1,
        },
      }}
      content={
        <Box component="div">
          <UText variant="body1">
            {t("overview.cancelUassist.subtitle")}
          </UText>
        </Box>
      }
      btnList={[

        <UButton
          key={t("overview.cancelUassist.noBtn")}
          variant="outlined"
          btnText={t("overview.cancelUassist.noBtn")}
          onClickHandler={onClose}
          sxProp={{
            height: 36,
          }}
        />,
        <UButton
          key={t("overview.cancelUassist.cancelBtn")}
          variant="contained"
          btnText={t("overview.cancelUassist.cancelBtn")}
          onClickHandler={() => handleConfirmCancelUAssist()}
          sxProp={{
            width: "auto",
            height: 36,
          }}
        />,
      ]}
    />
  )
}

export default CancelUAssistModal
